import { IntegrationsPage } from '@features/integrations/components/IntegrationsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/_ownAccount/integrations')({
  component: IntegrationsPage,
});
